import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider.module.js';

tns({
    container: '.cardSlider__inner',
    items: 4,
    controls: true,
    autoplay: false,
    gutter: 20,
    autoplayButtonOutput: false,
    edgePadding: 80,
    controlsText: ['', ''],
    responsive: {
        0: {
            items: 1,
            edgePadding: 50
        },
        480: {
            edgePadding: 80
        },
        760: {
            items: 2
        },
        1030: {
            items: 3
        },
        1280: {
            items: 4
        }
    }
});



// WEBPACK FOOTER //
// ./src/components/cardSlider/cardSlider.js